import React, { createContext, useCallback, useState } from "react";
import api from "../Services/api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const AuthContext = createContext({});

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => {
    const token = localStorage.getItem("@SaudeDoPovo:token");
    if (token) {
      return token;
    }
    return "";
  });

  const [user, setUser] = useState(() => {
    const user = localStorage.getItem("@SaudeDoPovo:user");
    if (user) {
      return JSON.parse(user);
    }
    return {};
  });

  const signIn = useCallback(
    async (data, setLoading, setLoginError, history) => {
      setLoading(true);
      var type = "";

      try {
        const response = await api.post("/auth/login", data);
        console.log(response.data);
        const token = response.data.token;
        // const refreshToken = response.data.refresh_token;
        if (response.data.user.medico || response.data.user.admin) {
          setToken(token);
          // setRefreshToken(refreshToken);
          setUser(response.data.user);
          localStorage.setItem("@SaudeDoPovo:token", token);
          // localStorage.setItem("@SaudeDoPovo:refreshToken", refreshToken);
          localStorage.setItem("@SaudeDoPovo:user", JSON.stringify(response.data.user));
          console.log("user", response.data.user);
          type = 'admin';
          if (response.data.user.medico) {
            type = 'medico';
          }
          // type = response.data.user.tipo;
          history.push("/perfil");
          const showToastMessage = () => {
            toast.success(`Seja bem-vindo(a) ${response.data.user.NO_primeiro_nome}!`, {
              position: toast.POSITION.TOP_CENTER,
            });
          };
          showToastMessage();
        } else {
          const showToastMessage = () => {
            toast.error("Login não autorizado para pacientes.", {
              position: toast.POSITION.TOP_CENTER,
            });
          };
          showToastMessage();
          setLoginError(true);
        }
      } catch (error) {
        console.log(error);
        console.log(error.msg);
        const showToastMessage = () => {
          toast.error(`Erro ao realizar o login.`, {
            position: toast.POSITION.TOP_CENTER,
          });
        };
        showToastMessage();
        setLoginError(true);
      }

      setLoading(false);
      return type;
    },
    []
  );


  const updateUserData = useCallback(
    async (data) => {
      console.log('usuario no context', user);
      console.log('vamos mudar pra isso', data);
      try {
        setUser(data);
        localStorage.setItem("@SaudeDoPovo:user", JSON.stringify(data));
        console.log('dados usuario alterados com sucesso no context')
        return;
      } catch (error) {
        console.log(error);
        console.log(error.msg);
        const showToastMessage = () => {
          toast.error(`Erro ao salvar novos dados do usuário.`, {
            position: toast.POSITION.TOP_CENTER,
          });
        };
        showToastMessage();
      }
      return;
    },
    [user]
  );

  const signOut = useCallback((history) => {
    localStorage.removeItem("@SaudeDoPovo:token");
    localStorage.removeItem("@SaudeDoPovo:user");
    setToken("");
    setUser({});
    history.push("/");
  }, []);

  const isAuthenticated = useCallback(() =>
    localStorage.getItem("@SaudeDoPovo:token") ? true : false, []);

  const isAuthorized = useCallback(() => {
    console.log("user");
    console.log(user);
    const userInfo = user;
    if (userInfo.admin) {
      return 'admin';
    }
    else {
      return 'medico';
    }
    // if (typeof userInfo === "string") {
    //   return userInfo ? JSON.parse(user).tipo : "";
    // } else {
    //   return userInfo.tipo;
    // }
  }, [user]);

  const contextValue = React.useMemo(() => ({
    signIn,
    signOut,
    updateUserData,
    token,
    user,
    setUser,
    isAuthorized,
    isAuthenticated,
  }), [signIn, signOut, updateUserData, token, user, isAuthorized, isAuthenticated]);

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
      <ToastContainer />
    </AuthContext.Provider>
  );
}
